import { Card } from '@shared/ui';
import { Link } from 'react-router';

/**
 * Catch-all, rendered inside the dashboard shell so someone who mistypes a URL
 * keeps their navigation.
 *
 * A static host answers every unknown path with the same `index.html` —
 * CloudFront maps 403/404 to it so that deep links like `/flags/<key>` reach the
 * router at all. The consequence is that the CDN can no longer tell anyone a URL
 * is wrong, because it cannot tell a real route from a typo. This component is
 * the only thing that can.
 */
export function NotFoundRoute() {
    return (
        <div className="mx-auto max-w-2xl">
            <Card>
                <div className="flex flex-col items-center gap-3 px-6 py-16 text-center">
                    <div className="text-[28px] font-semibold tracking-tight text-content-ghost">
                        404
                    </div>
                    <div className="text-base font-semibold text-content">Page not found</div>
                    <p className="max-w-md text-sm text-content-muted">
                        That URL doesn&apos;t match any Backoffice screen. It may have been renamed,
                        or the link may be stale.
                    </p>
                    <Link
                        to="/overview"
                        className="mt-1 rounded-lg border border-line bg-surface px-3 py-1.5 text-[13px] font-semibold text-content-body hover:bg-surface-sunken"
                    >
                        Back to Overview
                    </Link>
                </div>
            </Card>
        </div>
    );
}
